module.exports = __webpack_public_path__ + "img/operator1.3846f5d1.png";